import { Box } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import StatusWithColor from '../../components/Cards/helpers/StatusWithColor'
import CardWithSpace from '../../components/Cards/CardWithSpace'
import peopleIcon from '../../images/people.svg'
import finishFlagIcon from '../../images/finishFlag.svg'
import vectorIcon from '../../images/vector.svg'
import videoIcon from '../../images/video.svg'
import { ReactComponent as Change } from '../../images/Change.svg'
import LinearProgressWithLabel from '../../components/PageHelpers/LinearProgressWithLabel'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip'
import { selectUsersBatchActionsStatus } from '../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import TitleWithIcon from '../../components/Cards/helpers/TitleWithIcon'
import UseTranslation from '../../hooks/UseTranslation'
import { getFormattedDateWithoutDay, isNotEmpty } from '../../utils/helpers'
import Pagination from '../../components/PageHelpers/Pagination'
import { changeStatusProcessActionsStatusList, getUsersBatchActionsStatusList, statusEmployeesListPagination } from '../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'
import SideButtonContainer from '../../components/Cards/helpers/SideButtonContainerWithModal'

const BatchStatusList = () => {
  const history = useHistory()
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const availableStatuses = ['Finished', 'Waiting for Completion']
  const handleBatchDetailsClick = (batchActionsStatus) => {
    const statusName = batchActionsStatus?.status?.name
    if (availableStatuses.includes(statusName)) {
      history.push(`/users/status-details/${batchActionsStatus.id}`)
    }
  }

  const changeStatusHandler = (id) => {
    dispatch(changeStatusProcessActionsStatusList({ queries: id })).then((response) => {
      if (response.meta.requestStatus === 'fulfilled') {
        dispatch(getUsersBatchActionsStatusList())
      }
    })
  }

  return (
      <Box sx={styles.root}>
        {usersBatchActionsStatusStore.data?.map((batchActionsStatus) => (
        <CardWithSpace
            customStyles={{ ...styles.card, cursor: availableStatuses.includes(batchActionsStatus.status.name) ? 'pointer' : 'initial' }}
            key={batchActionsStatus.id}
             onClick={() => handleBatchDetailsClick(batchActionsStatus)}
        >
          <Box sx={styles.cardHeader}>
              <Box sx={styles.cardHeaderTitleWithIcon}>
              <TitleWithIcon
                title={t?.[batchActionsStatus.name]}
                icon={<Box component={'img'} src={peopleIcon} alt='peopleIcon' />}
                customStyle={styles.cardHeaderTitle}
                />
              <StatusWithColor
              status={batchActionsStatus.status.name}
              color={batchActionsStatus.status.color}
              customStyle={styles.cardHeaderStatus}
              />
              </Box>
                {batchActionsStatus.status.name === 'Under Process' && batchActionsStatus?.waiting_enabled && (
                <SideButtonContainer customStyle={styles.sideButton}>
                    <Box
                    onClick={() => changeStatusHandler(batchActionsStatus.id)}
                    sx={styles.sideButtonItem}>
                    <Change />
                      {`${t?.['Change to Waiting Status']}`}
                    </Box>
                </SideButtonContainer>
                )}
          </Box>
            <Box sx={styles.cardInfos}>
              <TitleWithIcon
                title={`${batchActionsStatus.all_count} Employees`}
                icon={
                  <HoverTooltip title={t?.['No. of Employees']}>
                    <Box component={'img'} src={vectorIcon} alt='vectorIcon' />
                    </HoverTooltip>
                }
                customStyle={styles.titleWithIcon}
              />
              <TitleWithIcon
                title={ getFormattedDateWithoutDay(batchActionsStatus.start_date)}
                icon={
                  <HoverTooltip title={`${t?.['Start Date']} - ${t?.Time}`}>
                        <Box component={'img'} src={videoIcon} alt='videoIcon' />
                    </HoverTooltip>
                }
                customStyle={styles.titleWithIcon}
              />
              <TitleWithIcon
                title={ isNotEmpty(batchActionsStatus.end_date) ? getFormattedDateWithoutDay(batchActionsStatus.end_date) : '– – –' }
                icon={
                    <HoverTooltip title={`${t?.['End Date']} - ${t?.Time}`}>
                      <Box component={'img'} src={finishFlagIcon} alt='finishFlagIcon' />
                    </HoverTooltip>
                }
                customStyle={styles.titleWithIcon}
              />

            </Box>

          <LinearProgressWithLabel
            label={`${batchActionsStatus.success_count}/${batchActionsStatus.all_count}`}
            percentage={
              Math.floor((batchActionsStatus.success_count / batchActionsStatus.all_count) * 100)
            }
          />
        </CardWithSpace>
        ))}
            <Pagination
            store={usersBatchActionsStatusStore}
            actionToDispatch={statusEmployeesListPagination} />
    </Box>
  )
}

const styles = {
  root: {
    mx: { xs: '10px', sm: 'unset' },
    marginBottom: { xs: '20px', sm: 'unset' },
  },
  card: {
    width: 'unset',
    p: '20px',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'start', sm: 'center' },
    gap: '10px',
  },
  cardHeaderTitleWithIcon: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: { xs: '10px', sm: 'unset' },
    alignItems: { xs: 'start', sm: 'center' },
  },
  cardHeaderTitle: {
    width: 'max-content',
    '& > div:nth-child(1)': {
      display: { xs: 'none', sm: 'initial' },
    },
  },
  cardHeaderStatus: {
    fontSize: { xs: '14px', sm: '16px' },
    fontWeight: 500,
  },
  titleWithIcon: {
    flex: 1,
    alignItems: { xs: 'flex-start', sm: 'center' },
    '& span': {
      fontSize: { xs: '14px', sm: '16px' },
    },
    '& img': {
      width: { xs: '15px', sm: '19px' },
      paddingRight: '5px',
    },
  },

  cardInfos: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    my: '10px',
    gap: '10px',
  },
  sideButton: {
    border: 'none',
    backgroundColor: { xs: '#fff', md: '#F7F9FB' },
    color: { xs: '#000000', md: 'icon.primary' },
    mx: 'auto',
  },
  sideButtonItem: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    justifyContent: { sm: 'center' },
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '10px 0px',
    margin: '0px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
    gap: '10px',
    fontFamily: 'Avenir, Roboto, monospace',
    '& svg:first-of-type': {
      display: { xs: 'flex', sm: 'none' },
      filter: 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)',
      width: '25px',
      height: '25px',
    },
  },
}

export default BatchStatusList
